import { render, staticRenderFns } from "./VotingDescription.vue?vue&type=template&id=6bd6a08e&scoped=true"
import script from "./VotingDescription.vue?vue&type=script&lang=js"
export * from "./VotingDescription.vue?vue&type=script&lang=js"
import style0 from "./VotingDescription.vue?vue&type=style&index=0&id=6bd6a08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd6a08e",
  null
  
)

export default component.exports